// ======================================================================
// File Name       : UploadConfigFileImport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import { CONFIG_FILE_ACCEPT_FILE } from '../../constants/ContentConstant';

class UploadConfigFileImport extends React.Component {
  render() {
    const { fileSize, fileName, disabled } = this.props;
    return (
      <div>
        <Col sm={12} className="margin-top-10">
          <RenderField
            type="batchimport"
            name="uploadFile"
            label="参照"
            validates={[VALIDATE_TYPE.ACCEPT_FILE, VALIDATE_TYPE.CONFIG_FILE_SIZE]}
            value={fileSize}
            fileName={fileName}
            fileSize={fileSize}
            fieldInput={10}
            fieldButton={2}
            accept={'application/zip,application/x-zip,application/x-zip-compressed'}
            acceptCheck={CONFIG_FILE_ACCEPT_FILE}
          />
        </Col>
        <Col sm={12} className="text-center margin-top-10">
          <Button variant="primary" className="btn-96" type="submit" disabled={disabled}>
            アップロード
          </Button>
        </Col>
      </div>
    );
  }
}

export default UploadConfigFileImport;
